export function devOnly(callback) {
    // Defined by rsbuild config
    // eslint-disable-next-line no-undef
    if (!APP_DEBUG) return;

    callback();
}
